import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback } from 'react';
import { Box, ListItemIcon, ListItemText, MenuItem, Typography } from '@mui/material';
import { Z3kRoutes } from 'z3k-settings/routes/type';
import { MobileToolbarWithPasswordWithRouter, } from 'console/dialogs/settings/withRouter/mobile-toolbar-with-password-router';
import { useNavigate } from 'react-router';
import { Visibility } from '@mui/icons-material';
import { ViewConfig } from 'z3k-settings/components/view-config';
import { useNavigateBack, useNavigateRoot } from 'shared/hooks/router';
export const Z3KDialogAppBarWithRouter = memo(function Z3KDialogAppBar(props) {
    const { showCloseButton, supportsServiceView, isServiceView, servicePassword, device_title, device_time, breadcrumbs, onSetServiceView, is_staff, } = props;
    const navigate = useNavigate();
    const onClose = useNavigateRoot();
    const onBack = useNavigateBack();
    const goInZ3kConfig = useCallback(() => {
        navigate(`/${Z3kRoutes.main_settings}/${Z3kRoutes.z3k_config}`, {
            state: {
                group_item: Z3kRoutes.main_settings,
                item_key: Z3kRoutes.z3k_config,
                item_id: null,
            },
        });
    }, []);
    return (_jsx(MobileToolbarWithPasswordWithRouter, { pageTitle: _jsxs(Box, { display: "flex", justifyContent: "center", children: [_jsx(Typography, { variant: "h6", children: device_title }), device_time] }), breadcrumbs: breadcrumbs, supportsServiceView: supportsServiceView, isServiceView: isServiceView, servicePassword: servicePassword, onBack: onBack, onClose: onClose, onSetServiceView: onSetServiceView, showCloseButton: showCloseButton, defaultPassword: "admin", additionalMenuItems: ViewConfig.isShown(isServiceView, {}, {}, is_staff) ? (_jsxs(MenuItem, { onClick: goInZ3kConfig, children: [_jsx(ListItemIcon, { children: _jsx(Visibility, {}) }), _jsx(ListItemText, { children: "Z3KConfigReader" })] })) : null }));
});
